import React, { FC } from 'react';
import AgeCategorySelector from '../../shared/common/AgeCategorySelector';
import LoanFormatDropDown from '../../shared/navigation/LoanFormatDropDown';
import SubNavigationLayout from '../../shared/navigation/SubNavigationLayout';
import { LinkContainer } from '../../shared/navigation/NavigationLinksContainer';
import { NavigationLink } from '../../shared/navigation/NavigationLink';
import { useQueryParams } from '../../shared/hooks/useQueryParams';
import { useTranslation } from 'react-i18next';
import { EXPIRY_REPORT, useFeature } from '../../shared/utils/togglz';
import { useAgeCategorySearchParam } from '../../shared/utils/useAgeCategorySearchParam';

type Props = {
    readonly isSticky: boolean;
    readonly showLoanFormatSelector: boolean;
    readonly showAgeCategorySelector: boolean;
};

const CollectionManagementNavigation: FC<Props> = ({ isSticky, showLoanFormatSelector, showAgeCategorySelector }) => {
    const { t } = useTranslation();
    const isExpiryReportEnabled = useFeature(EXPIRY_REPORT);

    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const {
        display: { value: displayQueryParam }
    } = useQueryParams({
        display: 'string'
    });

    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});
    if (displayQueryParam) {
        searchParams.set('display', displayQueryParam);
    }

    return (
        <SubNavigationLayout
            left={showLoanFormatSelector ? <LoanFormatDropDown showIcons={true} /> : null}
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink
                            to={{
                                pathname: `/collectionmgmt/collection`,
                                search: searchParams.toString()
                            }}
                        >
                            {t('menu.yourBorrowbox.collectionManagement.yourCollection')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/collectionmgmt/reserves">
                            {t('menu.yourBorrowbox.collectionManagement.reserves')}
                        </NavigationLink>
                    </li>
                    {isExpiryReportEnabled ? (
                        <li>
                            <NavigationLink to="/collectionmgmt/expiries">
                                {t('menu.yourBorrowbox.collectionManagement.expiries')}
                            </NavigationLink>
                        </li>
                    ) : null}
                    <li>
                        <NavigationLink to={{ pathname: '/collectionmgmt/campaigns', search: searchParams.toString() }}>
                            {t('menu.yourBorrowbox.collectionManagement.campaigns')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/collectionmgmt/subscriptions">
                            {t('menu.yourBorrowbox.collectionManagement.subscriptions')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/collectionmgmt/localcontent">
                            {t('menu.yourBorrowbox.collectionManagement.yourLocalContent')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={!isSticky && showAgeCategorySelector ? <AgeCategorySelector /> : null}
            isSticky={isSticky}
            width="20"
        />
    );
};

export default CollectionManagementNavigation;
